import {IListItem} from "../../../list-page/interfaces/interfaces";
import {getCategoryFromURL, sendGaEventImpressions} from "../../../../domain/marketing/gtm-provider";
import {PresetPluginDM} from "../interfaces";


export const sleep = (ms = 0) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
export const copyPresetLink = async (presetGuid:string,setShowLinkWasCopied: any) => {
    let link='https://'+window.location.host + '/studioverse/chain/' + presetGuid;
    await navigator.clipboard.writeText(link);
    setShowLinkWasCopied(true);
    await sleep(2500);
    setShowLinkWasCopied(false);

}
/**
 * send analytics data on page load
 */
export const sendProductImpressionAnalytics = (stateProducts: IListItem[], listName: string) => {


    const impressions = stateProducts.map((product, index) => {
        return {
            name: product.documentName,
            id: product.skuNumber,
            price: product.skuPrice,
            category: getCategoryFromURL(product.documentUrlPath),
            variant: 'NONE',
            list: listName,
            position: index + 1,
        };
    });

    sendGaEventImpressions(impressions);
};
export const getListItemByPresetPlugin = (plugin : PresetPluginDM,imgCdnDomain:string) : IListItem => {
    let newItemList = {} as IListItem;
    newItemList.skuid = plugin.skuid;
    newItemList.documentUrlPath = plugin.documentUrlPath;
    newItemList.documentName= plugin.documentName;
    newItemList.thumb = imgCdnDomain + plugin.thumb;
    newItemList.msrp = plugin.sku_MSRP;
    newItemList.skuPrice = plugin.skuPrice;
    newItemList.discount = plugin.discount;
    newItemList.note = plugin.note;
    newItemList.departmentID = plugin.departmentID;
    newItemList.couponCode = plugin.couponCode;
    newItemList.couponCampaignID = plugin.couponCampaignID;
    newItemList.couponPrice = plugin.couponPrice;
    newItemList.isProductOptions = plugin.isProductOptions;
    newItemList.variantsMinimalPrice = plugin.variantsMinimalPrice;
    newItemList.isPreorder = plugin.isPreorder;
    newItemList.reviewsTotal = plugin.reviewsTotal;
    newItemList.rating = plugin.rating;
    newItemList.saleEndDate = plugin.saleEndDate;
    newItemList.expectedShipping = plugin.expectedShipping;
    newItemList.sbsIncludedIn = plugin.sbsIncludedIn;
    newItemList.title = "SV Chain Featured Plugins";
    newItemList.skuEnabled = plugin.skuEnabled;
    return newItemList;
}